import { C, soft } from '@parsina/framework/clinical/src/constants/theme';
import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';

// Shared atoms for the mobile settings screen (mobile concept §5: new mobile UI
// is a component here first, the screen file is composition and wiring).

/** A titled card. One column, full-bleed rows, no desktop two-up grid. */
export const MobileSettingsCard = ({ title, hint, testId, children }) => (
  <section
    data-testid={testId}
    style={{
      background: C.card,
      border: `1px solid ${C.border}`,
      borderRadius: '0.875rem',
      boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
      padding: '0.875rem 1rem',
    }}
  >
    {title && (
      <h2 style={{ margin: 0, fontSize: '0.9375rem', fontWeight: 800, color: C.textPrimary }}>
        {title}
      </h2>
    )}
    {hint && (
      <p style={{ margin: '0.25rem 0 0', fontSize: '0.75rem', color: C.textMuted, lineHeight: 1.8 }}>
        {hint}
      </p>
    )}
    <div style={{ marginTop: title || hint ? '0.5rem' : 0 }}>{children}</div>
  </section>
);

/**
 * A read-only field row: label above, value below.
 * Used by the profile section, where editing happens in a BottomSheet rather
 * than inline — a phone screen full of live inputs behind a sticky nav is the
 * layout the mobile concept forbids (§6: one page-level scroll, docked submit).
 */
export const MobileFieldRow = ({ label, value, ltr, testId }) => (
  <div
    data-testid={testId}
    style={{
      display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
      gap: '1rem', padding: '0.6875rem 0',
      borderBottom: `1px solid ${C.border}`,
    }}
  >
    <span style={{ fontSize: '0.8125rem', color: C.textMuted, flexShrink: 0 }}>{label}</span>
    <span
      dir={ltr ? 'ltr' : 'auto'}
      style={{
        fontSize: '0.875rem', color: value ? C.textPrimary : C.textMuted,
        fontWeight: value ? 600 : 400, textAlign: 'end', minWidth: 0,
        overflowWrap: 'anywhere',
      }}
    >
      {value || '—'}
    </span>
  </div>
);

/** The «تکمیل پروفایل» strip — the mobile stand-in for the desktop dial. */
export const MobileCompleteness = ({ percent }) => {
  const { t, formatPercent } = useTranslation();
  return (
  <div data-testid="settings-completeness" style={{ marginTop: '0.75rem' }}>
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      fontSize: '0.75rem', marginBottom: '0.375rem',
    }}>
      <span style={{ color: C.textMuted }}>{t('settings.profile.completeProfile')}</span>
      <span style={{ color: C.textPrimary, fontWeight: 700 }}>{formatPercent(percent)}</span>
    </div>
    <div
      role="progressbar"
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={t('settings.profile.completeProfile')}
      style={{
        height: '0.375rem', borderRadius: 999,
        background: soft(C.navy, 0.12), overflow: 'hidden',
      }}
    >
      <div style={{ width: `${percent}%`, height: '100%', background: C.green, borderRadius: 999 }} />
    </div>
  </div>
  );
};
